module.exports = __webpack_public_path__ + "static/media/montreal.9fb7bb1c.jpg";